/**
 * @param {ChildNode} element 
 * @returns 
 */
 export function isUnorderedList (element) {
  return element.nodeName.toLowerCase() === 'ul'
}

/**
 * @param {ChildNode} element 
 * @returns 
 */
 export function isOrderedList (element) {
  return element.nodeName.toLowerCase() === 'ol'
}

/**
 * @param {ChildNode} element 
 * @returns 
 */
 export function isBold (element) {
  return element.nodeName.toLowerCase() === 'strong'
}

/**
 * @param {ChildNode} element 
 * @returns 
 */
 export function isItalic (element) {
  return element.nodeName.toLowerCase() === 'em'
}

/**
 * @param {ChildNode} element 
 * @returns 
 */
 export function isUnderlined (element) {
  return element.nodeName.toLowerCase() === 'u'
}

/**
 * @param {ChildNode} element 
 * @returns 
 */
 export function isText (element) {
  return element.nodeName.toLowerCase() === '#text'
}